import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
    ChangeOperation,
    ChangeTrackingValueFormatter,
    EntityChangeTrackingDto,
    IEntity,
} from '@pf/shared-common';
import {
    ChangeDescription,
    computeChangeDescriptions,
    computeChangeText,
} from '@pf/shared/util-platform';

@Component({
    selector: 'platform-change-view',
    templateUrl: './change-view.component.html',
    styleUrls: ['./change-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ChangeViewComponent {
    changeText?: string;
    changeDescriptions: ChangeDescription[] = [];
    showTree = false;

    @Input() entityName!: string;
    @Input() autoExpand = false;
    @Input() excludedFields: string[] = [];
    private _customValueTransformer?: ChangeTrackingValueFormatter;
    private _entityChange!: EntityChangeTrackingDto<IEntity>;

    @Input() set customValueTransformer(
        value: ChangeTrackingValueFormatter | undefined
    ) {
        this._customValueTransformer = value;
        this.rebuildDescriptions();
    }

    get customValueTransformer() {
        return this._customValueTransformer;
    }

    @Input() set entityChange(changeVm: EntityChangeTrackingDto<IEntity>) {
        this._entityChange = changeVm;
        if (!changeVm) {
            return;
        }
        this.setChangeText(changeVm.changes || [], this.excludedFields);
        this.rebuildDescriptions();
    }

    get entityChange() {
        return this._entityChange;
    }

    private rebuildDescriptions() {
        if (!this._entityChange) {
            return;
        }
        this.changeDescriptions = computeChangeDescriptions(
            this._entityChange.changes || [],
            this._entityChange.entity,
            this._customValueTransformer,
            this.excludedFields
        );
    }

    private setChangeText(
        changes: ChangeOperation[],
        excludedFields: string[] = []
    ) {
        const changeText = computeChangeText(changes, excludedFields);
        this.changeText = changeText;
    }
}
